import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-hospital-support-doc',
    templateUrl: './hospital-support-doc.component.html',
    styleUrls: ['./hospital-support-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HospitalSupportDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
